import React from 'react';
import styled from 'styled-components';
import { repoToAction } from "../helpers";

const Wrapper = styled.div`
  border: 1px solid #d1d5da;
  border-radius: 6px;

  pre {
    margin: 1em;
  }
`;

const Workflow = ({ repo }) => (
  <Wrapper>
    <pre>
      {`action "Sample Action" {
  uses = "${repoToAction(repo)}"
}`}
    </pre>
  </Wrapper>
);

export default Workflow;
